import { h } from "preact";
import { useMemo } from "preact/hooks";
import { useSession } from "../../hooks/session";
import { ITheme } from "../../interfaces/theme";
import { applyTheme } from "../../util/apply-theme";

export const ThemeWrapper = ({
  theme,
  children,
}: {
  theme: ITheme;
  children: any;
}) => {
  const [sessionState] = useSession();
  const variables = useMemo(() => {
    if (!theme) return {};
    const variables = applyTheme(theme, false, sessionState.mode);
    console.log("EUI");
    console.log(theme);
    console.log(variables);
    return variables;
  }, [theme, sessionState.mode]);
  return <span style={variables} className="THEME">{children}</span>;
};